// chili 寫出來的神秘 class name
const classNameWithForceAllChildElementUseCursorMove = '[&_*]:!cursor-move'

export function setMouseMoveEvent(
  element: HTMLElement,
  moveScrollType: 'all' | 'horizontal' | 'vertical' = 'all',
): void {
  let currentPosition: null | Record<'x' | 'y', number> = null
  let lockClickEvent = false

  // 避免被 img 的 draggable 影響到 mousemove 事件
  for (const item of element.querySelectorAll('img')) {
    if (item instanceof HTMLElement) {
      item.draggable = false
    }
  }

  switch (moveScrollType) {
    case 'all': {
      element.style.overflow = 'scroll'
      break
    }
    case 'horizontal': {
      element.style.overflow = 'scroll hidden'
      break
    }
    case 'vertical': {
      element.style.overflow = 'hidden scroll'
      break
    }
  }

  element.addEventListener('mousedown', (event) => {
    currentPosition = {
      x: event.clientX,
      y: event.clientY,
    }
    element.classList.add(classNameWithForceAllChildElementUseCursorMove)
    bindMouseMoveEvent()
  })

  element.addEventListener('mouseup', () => {
    liftMouseMoveEvent(true)
  })

  element.addEventListener('mouseleave', () => {
    liftMouseMoveEvent()
  })

  function mouseMoveEvent(event: MouseEvent): void {
    if (currentPosition === null) {
      return
    }
    const newPosition = {
      x: event.clientX,
      y: event.clientY,
    }
    // 有時點擊好像也會觸發到 mouse move 導致點擊事件失效
    // 所以多檢查 x y 需要有移動到才會往下執行
    if (newPosition.x === currentPosition.x && newPosition.y === currentPosition.y) {
      return
    }
    lockClickEvent = true
    if (moveScrollType === 'all' || moveScrollType === 'horizontal') {
      element.scrollLeft = element.scrollLeft + currentPosition.x - newPosition.x
    }
    if (moveScrollType === 'all' || moveScrollType === 'vertical') {
      element.scrollTop = element.scrollTop + currentPosition.y - newPosition.y
    }
    currentPosition = newPosition
  }

  function bindMouseMoveEvent(): void {
    element.addEventListener('mousemove', mouseMoveEvent)
    element.addEventListener(
      'click',
      (event) => {
        // 避免因為拖曳後放掉觸發了 mouseup 以後觸發到子元素的 click 事件
        // 所以加了捕獲事件，同時阻止捕獲
        //
        // 但因為需要判別是因為 mouse move 以後才觸發的 click 還是單次點擊事件
        // 所以在 mousemove 加了 lockClickEvent = true
        // 同時在 mouseup 加了 setTimeout 以後才執行 lockClickEvent = false
        // 用 lockClickEvent 去判別是不是拖曳事件
        if (lockClickEvent) {
          event.preventDefault()
          event.stopImmediatePropagation()
          lockClickEvent = false
        }
      },
      true,
    )
  }

  function liftMouseMoveEvent(delayLiftLockClickEvent = false): void {
    if (currentPosition === null) {
      return
    }
    element.classList.remove(classNameWithForceAllChildElementUseCursorMove)
    currentPosition = null
    element.removeEventListener('mousemove', mouseMoveEvent)
    if (delayLiftLockClickEvent) {
      window.setTimeout(() => {
        lockClickEvent = false
      }, 500)
    } else {
      lockClickEvent = false
    }
  }
}
